import React, { useState } from "react";
import styles from "./LanguageMenu.module.scss";
import classnames from "classnames";
import downSvg from "./down.svg";
import { FormattedMessage } from "react-intl";
import { Alternate } from "../../model/language";
import LanguageList from "./LanguageList";
import PlainButton from "../Button/PlainButton/PlainButton";
import Text from "../Text/Text";
import FocusTrap from "focus-trap-react";
import { useClickAway } from "react-use";

interface LanguageMenuProps {
  alternates: Alternate[];
  buttonClassName: string;
}

const LanguageMenu = ({ buttonClassName, alternates }: LanguageMenuProps) => {
  const [showMenu, setShowMenu] = useState<boolean>(false);
  const handleClick = () => setShowMenu(!showMenu);
  const buttonRef = React.useRef<HTMLButtonElement>(null);
  const menuRef = React.useRef<HTMLDivElement>(null);
  useClickAway(menuRef, e => {
    if (
      buttonRef.current &&
      e.target instanceof Node &&
      buttonRef.current.contains(e.target)
    ) {
      // Clicks on the button should only be handled by handleClick.
      return;
    }
    setShowMenu(false);
  });
  return (
    <div className={classnames(styles.root)}>
      <PlainButton onClick={handleClick} ref={buttonRef}>
        <Text className={buttonClassName} variant="defaultLight" as="span">
          <FormattedMessage id="language" defaultMessage="Language" />
        </Text>
        <img
          className={showMenu ? styles.rotate : undefined}
          width="14"
          height="14"
          src={downSvg}
          alt=""
        />
      </PlainButton>
      <FocusTrap
        active={showMenu}
        focusTrapOptions={{
          allowOutsideClick: true,
          onPostDeactivate: () => setShowMenu(false)
        }}
      >
        <LanguageList
          alternates={alternates}
          ref={menuRef}
          variant="defaultLight"
          className={showMenu ? styles.showMenu : styles.hideMenu}
        />
      </FocusTrap>
    </div>
  );
};

export default LanguageMenu;
